document.addEventListener('DOMContentLoaded', () => {
  const containers = document.querySelectorAll('.half-tone-container');
  
  containers.forEach(container => {
    const canvas = container.querySelector('.half-tone');
    const options = JSON.parse(container.dataset.options);
    
    if (!canvas) return;
    
    initHalfTone(canvas, options);
  });
});

function initHalfTone(canvas, options) {
  const ctx = canvas.getContext('2d');
  const image = new Image();
  image.crossOrigin = 'anonymous';
  image.src = options.src;
  
  image.onload = () => {
    const container = canvas.closest('.half-tone-container');
    const containerWidth = container.offsetWidth;
    const containerHeight = container.offsetHeight;

    // Set canvas size to exactly match container
    canvas.width = containerWidth;
    canvas.height = containerHeight;

    // Calculate scaled dot size
    const minDimension = Math.min(containerWidth, containerHeight);
    const scaledSize = Math.max(1.5, Math.round((minDimension / 300) * options.size));

    // Calculate image drawing dimensions to maintain aspect ratio
    const imageAspect = image.width / image.height;
    const containerAspect = containerWidth / containerHeight;
    
    let drawWidth, drawHeight, offsetX = 0, offsetY = 0;
    
    if (containerAspect > imageAspect) {
      drawWidth = containerHeight * imageAspect;
      drawHeight = containerHeight;
      offsetX = (containerWidth - drawWidth) / 2;
    } else {
      drawWidth = containerWidth;
      drawHeight = containerWidth / imageAspect;
      offsetY = (containerHeight - drawHeight) / 2;
    }

    // Draw and process the image
    ctx.fillStyle = 'white';
    ctx.fillRect(0, 0, containerWidth, containerHeight);
    ctx.drawImage(image, offsetX, offsetY, drawWidth, drawHeight);
    
    const imageData = ctx.getImageData(0, 0, containerWidth, containerHeight);
    const data = imageData.data;

    // Apply brightness and contrast
    for (let i = 0; i < data.length; i += 4) {
      const avg = (data[i] + data[i + 1] + data[i + 2]) / 3;
      let value = ((avg / 255 - 0.5) * options.contrast + 0.5) * 255;
      value *= options.brightness;
      value = Math.max(10, Math.min(245, value));
      data[i] = data[i + 1] = data[i + 2] = value;
    }

    // Clear canvas and set background
    ctx.fillStyle = 'white';
    ctx.fillRect(0, 0, containerWidth, containerHeight);

    // Draw halftone pattern
    const radius = scaledSize / 2;

    for (let y = 0; y < containerHeight; y += scaledSize) {
      for (let x = 0; x < containerWidth; x += scaledSize) {
        const i = (y * containerWidth + x) * 4;
        let brightness = data[i] / 255;
        brightness = Math.max(0.1, brightness);

        ctx.beginPath();
        ctx.ellipse(
          x + radius,
          y + radius,
          radius * brightness,
          radius * brightness,
          0,
          0,
          Math.PI * 2
        );
        ctx.fillStyle = '#357cf4';
        ctx.fill();
      }
    }
  };
}
